import { ReactNode } from "react";
import PiInputfield from "../../components/PiInputField";
import { EditorColumnHeader } from "./EditorColumn";

interface PresetColumnHeaderProps {
  icon: ReactNode;
  title: string;
  searchPlaceholder: string;
  search: string;
  onSearchChange: (value: string) => void;
  testId?: string;
}

/** The scene page's column header, with a search box under it, on top of the actor and prop preset lists. */
export default function PresetColumnHeader(props: PresetColumnHeaderProps) {
  const { icon, title, searchPlaceholder, search, onSearchChange, testId } = props;

  return (
    <div className="flex-shrink-0" data-testid={testId}>
      <EditorColumnHeader icon={icon} title={title} />
      <div className="px-[10px] pt-[10px] pb-[4px]">
        <PiInputfield
          label=""
          placeholder={searchPlaceholder}
          ariaLabel={searchPlaceholder}
          value={search}
          onChange={onSearchChange}
          showSearchIcon
          showCrossIcon
          size="compact"
          debounceTime={150}
        />
      </div>
    </div>
  );
}

/** Case-insensitive substring match; an empty query matches everything. */
export function matchesPresetSearch(name: string | undefined, search: string): boolean {
  const query = search.trim().toLowerCase();
  if (!query) return true;
  return (name ?? "").toLowerCase().includes(query);
}
